import React from "react";
import { useEffect,useState } from "react";
import cataloglist from "../data/catalog.json";
import { Button } from "./Button";
import axios from "axios";
import { Link } from "react-router-dom";
const Catalog = () => {
    const [allDocuments, setAllDocuments] = useState([]);
      const documents = async () => {
    try {
      const response = await axios.post(
        "https://api.bbf-bike.de/api/documents/downloads",
        { data: "bbf-bike/documents/new-catalogs" },
      );
      setAllDocuments(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    documents();
  }, []);

 
  const newCatalogsDetails = [
    {
    brand: "BBF Bike Kids",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('kids')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/bbf_kids.png'
    },
       {
    brand: "BBF Bikes",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('bikes')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/bbf_bike_katalog.png'
    },
           {
    brand: "BBF E-Bikes",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('e__bikes')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/bbf_e-bike.png'
    },
               {
    brand: "BBF Bike Cargo",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('cargo')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/bbf-cargo.png'
    },
                   {
    brand: "Checker Pig",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('checker')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/checker-pig_kataloglogo.png'
    },
                       {
    brand: "Columbus",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('columbus')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/columbus_katalog.png'
    },
                           {
    brand: "Dahon",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('dahon')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/dahonkatalog.png'
    },
                               {
    brand: "Panther",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('panther')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/pantherkatalog.png'
    },
                                   {
    brand: "Lehmkuhl",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('lehmkuhl')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/Lehmkuhl_Cover.jpg'
    },
                                      {
    brand: "Viva",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('viva')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/Viva_Cover.jpg'
    },
                                          {
    brand: "Bottecchia",
    catalog: allDocuments.find((item)=>item.toLowerCase().includes('bottecchia')),
    symbol:'https://media.bbf-bike.de/shop/documents/websites/bbf-bike/images/brands/Katalog_Bottecchia_REPARTO-CORSE_Cover.png'
    }
]
  return (
    <div className="min-h-[calc(100vh-100px)] h-auto ">
      <div className="lg:pt-[160px] sm:pt-0  md:pt-10">
        <div className="flex justify-center items-center xs:my-10 md:my-16 xl:my-20">
          <div className="grid lg:grid-cols-4 md:grid-cols-3 md:gap-[89px]  sm:grid-cols-3 xl:gap-24 xs:gap-4 ">
            {newCatalogsDetails.map((item, index) => (
              <div key={index}>
                <a href={`https://media.bbf-bike.de/shop/documents/bbf-bike/documents/new-catalogs/${item.catalog}`} target="_blank">
                  <img
                    src={item.symbol}
                    className="xl:h-[230px] lg:h-[120px]  xl:w-[230px] 
                  lg:w-[120px] 
                  xs:w-[110px] xs:h-[110px]  md:w-[150px] md:h-[150px] object-contain  bg-bbf-brand transition md:ease-in-out md:delay-150  md:hover:-translate-y-1 md:hover:scale-110  md:duration-500 "
                  />
                </a>
                <div
                  className="font-roboto-light flex justify-start items-start flex-col  font-semibold text-[14px] xl:w-[230px] 
                  lg:w-[120px] 
                  xs:w-[110px] md:w-[150px]  bg-opacity-60 auto-rows-max xs:h-[140px] md:h-[80px] leading-6 mt-4"
                >
                  <p className="pb-2">{item?.catalog?.split('-')[0].replace('__','-').replaceAll('_',' ').replace('.pdf','')}</p>
            <p>{item?.catalog?.replaceAll('_',' ').replace('.pdf','').split('-')[1]}</p>
                  
                </div>
              </div>
            ))}
          </div>
            
        </div>
          <div className="flex justify-center items-center mb-8">
            <Link to="/archiv">
                <Button text="Archiv"   color="bbf-black"/>
            </Link>
   
        </div>
      </div>
    </div>
  );
};

export default Catalog;
